import { render, staticRenderFns } from "./CurrencyDialog.vue?vue&type=template&id=38167e2f&scoped=true&"
import script from "./CurrencyDialog.vue?vue&type=script&lang=js&"
export * from "./CurrencyDialog.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyDialog.vue?vue&type=style&index=0&id=38167e2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38167e2f",
  null
  
)

export default component.exports